import { ICreateAccountResponse } from '../dtos/responses/create-account.response';
import { AccountsListApiResponse } from '../dtos/responses/accounts-list-response';
import { ICreateAccountRequest } from '../dtos/requests/create-account.request';
import { IUpdateAccountRequest } from '../dtos/requests/update-account.request';
import { userManagementUrl, Accounts } from '../../../../../constants';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeprecatedPaginationParameters } from '../../../../../trash/shared/interfaces/shared-interfaces';
import { IAssignScopesRequest, IRevokeScopesRequest } from '../dtos';

@Injectable({
  providedIn: 'root'
})
export class AccountsService {
  collectionUrl: string = `${userManagementUrl}/${Accounts}`;

  constructor(private http: HttpClient) {}

  getAll(params?: DeprecatedPaginationParameters): Observable<AccountsListApiResponse> {
    let paramsItem = new HttpParams();

    // Loop through the parameters and append them if defined
    if (params) {
      Object.keys(params).forEach((key) => {
        const value = (params as any)[key];
        if (value !== undefined && value !== null && value !== '') {
          paramsItem = paramsItem.append(this.mapParamKey(key), value);
        }
      });
    }

    // Return the HTTP GET call with the expected response type
    return this.http.get<AccountsListApiResponse>(`${this.collectionUrl}`, { params: paramsItem });
  }
  // Helper method to map parameter keys if needed (optional)
  private mapParamKey(key: string): string {
    const map: { [key: string]: string } = {
      sortColumn: 'SortColumn',
      sortOrder: 'SortOrder',
      searchField: 'SearchField',
      SearchKeyword: 'SearchKeyword',
      page: 'Page',
      pageSize: 'PageSize',
      order: 'Order',
      orderBy: 'OrderBy'
    };
    return map[key] || key;
  }

  // Create a new resource (POST)
  async create(request: ICreateAccountRequest): Promise<Observable<ICreateAccountResponse>> {
    return await this.http.post<ICreateAccountResponse>(`${this.collectionUrl}`, request);
  }

  // Update a resource (PUT)
  async update(request: IUpdateAccountRequest, id: number | string): Promise<Observable<void>> {
    return await this.http.patch<void>(`${this.collectionUrl}/${id}`, request);
  }

  // Assign Specialized Roles(POST)
  async AssignScopesToAccount(request: IAssignScopesRequest, id: number | string): Promise<Observable<any>> {
    return await this.http.post<any>(`${this.collectionUrl}/${id}/scopes`, request);
  }

  // Revoke Specialized Roles(DELETE)
  async RevokeScopesToAccount(request: IRevokeScopesRequest, id: number | string): Promise<Observable<any>> {
    return await this.http.delete<any>(`${this.collectionUrl}/${id}/scopes`, {
      body: request
    });
  }

  // Get a single resource by ID (GET)
  // getById(id: string): Observable<TResponse> {
  //   return this.http.get<TResponse>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }

  // Delete a single resource by ID (DELETE)
  // delete(id: string): Observable<void> {
  //   return this.http.delete<void>(`${this.baseUrl}/${this.collectionName}/${id}`);
  // }
}
